import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"item-text":"text","item-value":"value","items":_vm.types,"label":_vm.$t('Price Type'),"outlined":"","hide-details":"auto"},model:{value:(_vm.price_type),callback:function ($$v) {_vm.price_type=$$v},expression:"price_type"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }